import React from 'react';

import PhoneNumber from '~/components/Columns/PhoneNumber';

import { type ColumnDefinition, ModelColumns } from '~/types/components';
import type { SourcePhoneNumber } from '~/types/models';

export const Columns: Array<ColumnDefinition<SourcePhoneNumber>> = [
  {
    title: 'Numéro',
    key: 'number',
    mask: '(###) ###-####',
    render: (v) => <PhoneNumber value={v} />,
    sortable: true,
    type: 'string',
  },
  ...ModelColumns,
];
